module.exports = __webpack_public_path__ + "img/w3_logout_white.f7be3f7e.png";